// removed by extract-text-webpack-plugin
module.exports = {"userCard":"userCard___3R5oG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Admin/UsersManagement/UsersCard/styles.module.scss
// module id = 2685
// module chunks = 0